<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tagMonitoringData"
      style="width: 100.1%;"
    >
      <!-- 删除 -->
      <template slot-scope="{ row, index }" slot="operations">
        <Button
          type="info"
          size="small"
          @click="execute(row.id)"
          :loading="executeLoading"
          v-hasPermission="['labelManagement:tagMonitoring:execute']"
          >立即执行</Button
        >
        <Button
          type="warning"
          v-hasPermission="['labelManagement:tagMonitoring:update']"
          size="small"
          @click="addOrUpdateHandle(row)"
          >编辑</Button
        >
        <span @click="doDelete(index)">
          <Button
            type="error"
            v-hasPermission="['labelManagement:tagMonitoring:delete']"
            size="small"
            @click="delModel = true"
            >{{ $t("common.del") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 删除 -->
    <Modal v-model="delModel" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>您确定删除该记录吗 ?</p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="delLoading"
          @click="removeTagMonitoring()"
          >{{ $t("common.del") }}
        </Button>
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
    <!-- 弹窗，新增/编辑 -->
    <add-or-update-tag-monitoring
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
    ></add-or-update-tag-monitoring>
  </div>
</template>
<script>
import AddOrUpdateTagMonitoring from "./AddOrUpdateTagMonitoring";

var tableTagMonitoringVue = {};
export default {
  name: "TableTagMonitoring",
  components: {
    AddOrUpdateTagMonitoring
  },
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      executeLoading: false,
      addOrUpdateVisible: false,
      delModel: false,
      delLoading: false,
      loading: true,
      params: {},
      columns: [
        {
          title: "规则名称",
          width: 120,
          key: "ruleName"
        },
        {
          title: "云平台",
          width: 120,
          key: "cloudTypeName"
        },
        {
          title: "公司",
          width: 200,
          key: "companyName"
        },
        {
          title: "账号",
          width: 120,
          key: "accountName"
        },
        {
          title: "区域",
          width: 120,
          key: "region"
        },

        {
          title: "资源类型",
          width: 120,
          key: "resourceName"
        },
        {
          title: "键",
          width: 120,
          key: "key"
        },
        {
          title: "关系 ",
          width: 120,
          key: "relationName"
        },
        {
          title: "值",
          width: 120,
          key: "value"
        },
        {
          title: "联系人",
          width: 270,
          key: "contactEmailList"
        },
        {
          title: "操作",
          width: 200,
          slot: "operations"
        }
      ],
      ruleValidate: {},
      tagMonitoringData: []
    };
  },
  beforeCreate: function() {
    tableTagMonitoringVue = this;
  },
  mounted: function() {
    tableTagMonitoringVue.getTagMonitoringData();
  },
  methods: {
    showAll: function(params) {
      // 对象深度Copy
      tableTagMonitoringVue.params = JSON.parse(JSON.stringify(params));
      tableTagMonitoringVue.getTagMonitoringData();
    },
    // 分页显示数据
    getTagMonitoringData: function() {
      // 列表分页
      this.$api.resourceTagWarning
        .page({
          ruleName: tableTagMonitoringVue.params.ruleName,
          cloudType: tableTagMonitoringVue.params.cloudType,
          companyId: tableTagMonitoringVue.params.companyId,
          accountId: tableTagMonitoringVue.params.accountId,
          region: tableTagMonitoringVue.params.region,
          resourceType: tableTagMonitoringVue.params.resourceType,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tagMonitoringData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableTagMonitoringVue.getTagMonitoringData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableTagMonitoringVue.getTagMonitoringData();
    },
    /**
     * 立即执行
     */
    execute: function(id) {
      if (this.StringUtils.isNotEmpty(id)) {
        this.executeLoading = true;
        this.$api.resourceTagWarning
          .execute("id", id)
          .then(res => {
            this.$Message.success("执行成功!");
          })
          .catch(res => {
            this.$Message.error("执行失败!");
          });
        this.executeLoading = false;
      }
    },
    /**
     * 编辑报警规则
     */
    addOrUpdateHandle: function(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    /**************************删除****************************/
    // 删除
    doDelete: function(index) {
      this.lineIndex = index;
    },
    removeTagMonitoring: function() {
      let lineIndex = this.lineIndex;
      // 删除
      this.$api.resourceTagWarning
        .delete("id", this.tagMonitoringData[lineIndex].id)
        .then(res => {
          this.delLoading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            // 21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableTagMonitoringVue.getTagMonitoringData();
            this.delLoading = false;
            this.delModel = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/label_management/tag_monitoring/TableTagMonitoring.vue